import React from "react";

function normalizeTransactionTypeKey(type) {
  if (type === "summary" || type === "space") {
    return null;
  }
  if (type === undefined || type === null || type === "") {
    return null;
  }
  if (typeof type === "string") {
    const n = parseInt(type, 10);
    return Number.isNaN(n) ? null : n;
  }
  if (typeof type === "number") {
    return type;
  }
  return null;
}

/**
 * Tyyppi-sarakkeen pill-badge — sama ulkoasu kuin TransactionsList (badge-transaction-type + paletti).
 * @param {number|string|undefined} type — row.type (numerona tai merkkijonona, esim. päiväkirjan yhteenvedossa "2")
 * @param {import("i18next").TFunction} t
 * @param {(key: number) => { value?: string } | null} getTransactionType — AppContext
 */
export function renderTransactionTypeBadge(type, t, getTransactionType) {
  const typeKey = normalizeTransactionTypeKey(type);
  if (typeKey === null) {
    return null;
  }

  const transactionTypeValue = getTransactionType(typeKey)?.value;

  const typeBadge = (colorClass, translationKey, translationDefault) => (
    <span className={`badge badge-pill badge-transaction-type ${colorClass}`}>
      {t(translationKey, translationDefault)}
    </span>
  );

  if (transactionTypeValue === "Buy") {
    return typeBadge("badge-danger", "transactionTypeValue_2", transactionTypeValue);
  }
  if (transactionTypeValue === "Sell") {
    return typeBadge("badge-palet-mint-green", "transactionTypeValue_3", transactionTypeValue);
  }
  if (transactionTypeValue === "Split") {
    return typeBadge("badge-palet-light-blue", "transactionTypeValue_20", transactionTypeValue);
  }
  if (transactionTypeValue === "Dividend") {
    return typeBadge("badge-palet-purple", "transactionTypeValue_30", transactionTypeValue);
  }
  if (transactionTypeValue === "DividendOwn") {
    return typeBadge("badge-palet-lavender", "transactionTypeValue_32", transactionTypeValue);
  }
  // Korot lainoista. Argonin badge-variantti vaalentaa taustan: mint-green on jo Myynti, ja
  // light-salmon/coral vaalenevat valkoisiksi, joten korolle olive-green ja pääomitetulle brown-ishred.
  if (transactionTypeValue === "Interest" || typeKey === 33) {
    return typeBadge("badge-palet-olive-green", "transactionTypeValue_33", "Korko");
  }
  if (transactionTypeValue === "InterestCapitalized" || typeKey === 34) {
    return typeBadge("badge-palet-brown-ishred", "transactionTypeValue_34", "Korko, pääomitettu");
  }
  if (typeKey === 50) {
    return typeBadge("badge-gray-500", "transactionTypeValue_50", "MUU KULU/TUOTTO");
  }
  return typeBadge("badge-info", "transactionTypeValue_41", transactionTypeValue);
}
